<script>
import FeaturePlaceholder from './FeaturePlaceholder.vue';
export default {
  components: { FeaturePlaceholder },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div
    class="flex flex-col items-center justify-center h-full px-6 text-center"
  >
    <div
      class="mb-5 grid size-28 place-content-center rounded-2xl border border-[#2563EB]/20 bg-slate-50 shadow-lg shadow-blue-950/5 dark:border-white/10 dark:bg-[#0B1220]"
    >
      <img
        class="w-16 hidden dark:block"
        src="dashboard/assets/images/no-chat-dark.svg"
        alt="No conversations"
      />
      <img
        class="w-16 block dark:hidden"
        src="dashboard/assets/images/no-chat.svg"
        alt="No conversations"
      />
    </div>
    <span class="max-w-sm text-sm leading-6 text-n-slate-12 font-medium">
      {{ message }}
      <br />
    </span>
    <!-- Cmd bar, keyboard shortcuts placeholder -->
    <FeaturePlaceholder />
  </div>
</template>
